import { Stack, Typography, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";
import type { ObjPathProxy } from "ts-object-path";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	count?: number;
	labelKey?: ObjPathProxy<unknown, string>;
	action?: ReactNode;
};

export const ListCountBarRedesign: FC<Props> = ({
	count,
	labelKey,
	action,
}) => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<Stack
			direction="row"
			alignItems="center"
			justifyContent="flex-end"
			px={theme.spacingTokens.lg}
			py={theme.spacingTokens.sm}
			bgcolor={theme.palette.grey[50]}
		>
			{labelKey && (
				<Typography
					variant="caption"
					color={theme.palette.grey[500]}
					marginRight="auto"
				>
					{t(labelKey, { count })}
				</Typography>
			)}
			{action}
		</Stack>
	);
};
